import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {NumeralService} from "../../services/Numeral.service";
import {StateService} from "../../services/StateService";
import {LogoService} from "../../services/LogoService";
import {LoadingService} from "../../services/LoadingService";
import {LOGIN_LOGO_CSS, TOAST_TYPE} from "../../constants/Tpiq.constants";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {PageTitleService} from "../../services/PageTitle";
import {ExportService} from "../../services/Export.service";
import {Session} from "../../services/Session";
import {environment} from "../../../environments/environment";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {ModelBasedNumeral} from "../../directives/model-numeral";
import {FormatAmountPipe} from "../../pipes/format-amount.pipe";

declare const _: any;
declare const moment: any;
declare const jQuery: any;

@Component({
  selector: 'app-customer-tax-estimates',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, ModelBasedNumeral, FormatAmountPipe],
  templateUrl: './customer-tax-estimates.component.html',
  styleUrl: './customer-tax-estimates.component.scss'
})
export class CustomerTaxEstimatesComponent implements OnInit, OnDestroy {
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  org: string;
  orgName: string;
  user: any = {};
  publishedPlans: any;
  selectedPlan: any;
  currentPlanId: any;
  taxEstimates: any = {
    id: '',
    planId: '',
    priorYearTax: '',
    priorYearAGI: '',
    currentYearTax: '',
    currentYearAGI: '',
    filingStatus: '',
    notes: '',
    status: ''
  };
  projections: Array<any> = [
    {
      id: '',
      estimateId: '',
      projectionName: 'Federal 1040 Tax Projection',
      notes: '',
      recommendedEstimates: '',
      paidEstimates: '',
      safeHarbor: '',
      currentYearExpectedMinTaxDue: '',
      minimumAmountDueToIRS: '',
      overPaymentAppliedForPY: '',
      estimatedW2WithHolding: '',
      quarter1: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter2: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter3: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter4: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment1: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment2: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      remainderDueRefund: '',
      isRemainderDueOrRefundNegative: false
    },
    {
      id: '',
      estimateId: '',
      projectionName: 'State Personal Tax Projection',
      notes: '',
      recommendedEstimates: '',
      paidEstimates: '',
      priorYearTaxDue: '',
      currentYearExpectedMinTaxDue: '',
      minimumAmountDueToIRS: '',
      overPaymentAppliedForPY: '',
      estimatedW2WithHolding: '',
      quarter1: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter2: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter3: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter4: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment1: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment2: {recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      remainderDueRefund: '',
      isRemainderDueOrRefundNegative: false
    },
    {
      id: '',
      estimateId: '',
      projectionName: 'C-Corp Federal Tax Projection',
      notes: '',
      recommendedEstimates: '',
      paidEstimates: '',
      safeHarbor: '',
      currentYearExpectedMinTaxDue: '',
      minimumAmountDueToIRS: '',
      overPaymentAppliedForPY: '',
      estimatedW2WithHolding: '',
      quarter1: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter2: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter3: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter4: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment1: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment2: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      remainderDueRefund: '',
      isRemainderDueOrRefundNegative: false
    },
    {
      id: '',
      estimateId: '',
      projectionName: 'C-Corp State Tax Projection',
      notes: '',
      recommendedEstimates: '',
      paidEstimates: '',
      safeHarbor: '',
      currentYearExpectedMinTaxDue: '',
      minimumAmountDueToIRS: '',
      overPaymentAppliedForPY: '',
      estimatedW2WithHolding: '',
      quarter1: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter2: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter3: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      quarter4: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment1: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      addittionalPayment2: {dueDate: '', recommended: '', paid: '', paidDate: '', notes: '', todoId: '', id: ''},
      remainderDueRefund: '',
      isRemainderDueOrRefundNegative: false
    }
  ];
  showProjection: boolean = false;
  backgroundColor: string;
  bgColor: string;
  orgLogo: string;
  exportedDate: any;
  currentEnvironment: any;
  userName: any;
  constructor(
    private toastService: ToastService,
    private loadingService: LoadingService,
    private titleService: PageTitleService,
    private taxPlanningService: TaxPlanningService,
    private numeralService: NumeralService,
    private stateService: StateService,
    private logoService: LogoService,
    private exportService: ExportService
  ) {}

  ngOnInit(): void {
    this.org = Session.getOrg();
    let user: any = Session.getUser('delegatedFrom');
    this.userName = user.first_name + ' ' + user.last_name;
    this.user = user.id;
    this.orgName = user.org || '';
    this.currentEnvironment = environment;
    this.orgLogo = this.logoService.getLoginLogoUrl();
    const orgCssArray = LOGIN_LOGO_CSS[this.org] || [];
    if (orgCssArray && orgCssArray.length > 0) {
      const orgCss = _.find(orgCssArray, {style: 'background-color'}) || {};
      this.bgColor = orgCss.value;
    }
    this.backgroundColor = this.bgColor ? this.bgColor : '#fff';
    this.exportedDate = moment(new Date()).format('MM/DD/YYYY');
    this._init();
  }

  _init(){
    const base = this;
    this.titleService.setPageTitle('Tax Estimates');
    this.getPublishedPlansForTaxEstimates();
  }

  getPublishedPlansForTaxEstimates() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getPublishedPlansForTaxEstimates(this.org, this.user, this.user)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.publishedPlans = (response) ? response : [];
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get plans data');
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  formatAmount(amount){
    return this.numeralService.format('$0,0', amount);
  }

  setPlan(plan) {
    this.showProjection = false;
    this.selectedPlan = plan;
    this.currentPlanId = plan.planId;
    this.getPlanTaxEstimates();
  }

  getPlanTaxEstimates() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getPlanTaxEstimates(this.org, this.user, this.currentPlanId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (response && response.id) {
          this.setUpTaxEstimateValues(response);
        }
        this.showProjection = true;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get tax estimates');
      });
  }

  setUpTaxEstimateValues(response) {
    const base = this;
    if (response) {
      this.taxEstimates.id = response.id;
      this.taxEstimates.planId = (response.planId) ? response.planId : this.currentPlanId;
      this.taxEstimates.currentYearTax = response.currentYearTax;
      this.taxEstimates.currentYearAGI = response.currentYearAGI;
      this.taxEstimates.priorYearTax = response.priorYearTax;
      this.taxEstimates.priorYearAGI = response.priorYearAGI;
      this.taxEstimates.filingStatus = response.filingStatus;
      this.taxEstimates.notes = response.notes;
      this.taxEstimates.status = response.status;
      if (response.projections && response.projections.length > 0) {
        const projections = [];
        _.each(response.projections, function (estimate) {
          let projection = JSON.parse(estimate.projectionData).projection;
          if (projection) {
            projection.id = estimate.id;
            projections.push(projection);
          }
        });
        this.projections = projections;
      }
    }
  }

  exportToPdf() {
    const pdfReq = this.getPDFRequestObject();
    const url = '/TaxPlanningServices/orgs/' + this.org + '/users/' + this.user + '/export/pdf';
    this.loadingService.triggerLoadingEvent(true);
    this.exportService.exportReportIntoFile(url, pdfReq)
      .subscribe(data => {
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([data], {type: 'application/pdf'});
        const link = jQuery('<a></a>');
        link[0].href = URL.createObjectURL(blob);
        link[0].download = `Tax Estimates.pdf`;
        link[0].click();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Into PDF');
      });

  }

  getPDFRequestObject(){
    let styleString = '';
    const styleHtml = jQuery('style').clone();
    if (styleHtml && styleHtml.length >= 2){
      for (let i = 1; i < styleHtml.length; i++){
        styleString += styleHtml[i].outerHTML;
      }
    }
    const img = `<img width="130%" src="${this.orgLogo}"/>`;
    let html = jQuery('<div>').append(styleString).append(jQuery('#customer-tax-estimate-projection').clone()).html();
    html = html.replace('````', img);
    this.loadingService.triggerLoadingEvent(true);
    const pdfReq = {
      version : '1.1',
      genericReport: {
        payload: html,
        footer: moment(new Date()).format('MMMM DD, YYYY HH:mm a')
      }
    };
    return pdfReq;
  }

  exportToExcel() {
    let urlString = (this.currentEnvironment.production) ? 'https://services.taxplaniq.com' : 'https://dev-services.taxplaniq.com';
    const data: any = {};
    data.planId = this.currentPlanId;
    data.reportName = 'tax_estimates';
    data.orgId = this.org;
    data.userId = this.user.id;
    data.orgName = this.orgName;
    data.logoUrl = this.orgLogo;
    data.clientName = this.userName;
    data.planName = (this.selectedPlan && this.selectedPlan.planName) ? this.selectedPlan.planName : '';
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.exportROIExcel(this.org, this.user, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Tax Planning.xls`;
        link.click();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Into Excel');
      });
  }

}
